export { default } from './src/ActivitiesWidget';
export { LikesMergeObserver } from '@ott/activity-card';
